// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"baw_a"};